const icon = require('vue-svgicon');
icon.register({
    'check': {
        width: 20,
        height: 22,
        viewBox: '0 0 20 22',
        data: `<path pid="0" d="M6.343 17.92l-4.956-5.376-.504.476 5.6 8.54L19.391 1.4l-.588-.42-12.46 16.94z" _fill="#000"/>`,
    },
});
